var SITE_SETTINGS_API_CONFIG = {
    baseUrl: '',
    isExternalContent: false,
    marketLocale: '',
    siteContext: "jabra" /* Jabra */,
};
export var getSiteSettingsApiConfig = function () {
    return SITE_SETTINGS_API_CONFIG;
};
export var setSiteSettingsApiConfig = function (config) {
    SITE_SETTINGS_API_CONFIG.baseUrl = config.baseUrl;
    SITE_SETTINGS_API_CONFIG.isExternalContent = config.isExternalContent;
    SITE_SETTINGS_API_CONFIG.marketLocale = config.marketLocale;
    SITE_SETTINGS_API_CONFIG.siteContext = config.siteContext;
};
